// Hostname of the sandbox deployment. The frontend bundle is identical across
// environments (same .env.production), so the environment is derived from the
// hostname - same approach as the production check in index.js.
export const SANDBOX_HOSTNAME = "app.sandbox.trilodocs.com";

// Demo accounts that get the read-only file upload overlay on sandbox.
export const DEMO_ACCOUNT_EMAILS = [
  "trilodocs@demo1.com",
  "trilodocs@demo2.com",
  "trilodocs@demo3.com",
];

export const isSandboxEnvironment = () =>
  window.location.hostname === SANDBOX_HOSTNAME;

export const isDemoAccount = email =>
  !!email && DEMO_ACCOUNT_EMAILS.includes(email.trim().toLowerCase());

// True only on sandbox AND only for the demo accounts listed above.
export const isSandboxDemoAccount = email => {
  // return isSandboxEnvironment() && isDemoAccount(email);
  // for testing
  console.log("isSandboxDemoAccount called with email:", email);
  return false;
};
